import React from "react";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { statusLabels, fileTypeLabels, AccessLabel, LABEL_HTML } from "../../contants";

const TYPE_DISPLAY_MAPPING = {
	htmlText: LABEL_HTML
};

const AssetFilters = ({ filters, onFilterChange }) => {
	const { t } = useTranslation();

	const handleChange = filterType => (event, newValue) => {
		onFilterChange(filterType, newValue);
	};

	const getTypeDisplayLabel = option => {
		return TYPE_DISPLAY_MAPPING[option] || t(`ASSETS.TYPE.${option}`, { defaultValue: option });
	};

	return (
		<Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
			{/* Status Filter */}
			<Autocomplete
				multiple
				id="status-filter"
				options={statusLabels.map(option => option.value)}
				getOptionLabel={option => t(`ASSETS.STATUS.${option}`, { defaultValue: option })}
				value={filters.status || []}
				onChange={handleChange("status")}
				filterSelectedOptions
				renderTags={(value, getTagProps) =>
					value.map((option, index) => {
						const { key, ...tagProps } = getTagProps({ index });
						return (
							<Chip
								key={key}
								label={t(`ASSETS.STATUS.${option}`, { defaultValue: option })}
								{...tagProps}
							/>
						);
					})
				}
				renderInput={params => (
					<TextField
						{...params}
						label={t("SOURCES.FILTERS.status")}
						placeholder={t("SOURCES.FILTERS.selectStatus")}
						size="small"
						sx={{ minWidth: 200 }}
					/>
				)}
			/>

			{/* Access Filter */}
			<Autocomplete
				multiple
				id="access-filter"
				options={AccessLabel.map(option => option.value)}
				getOptionLabel={option => t(`ASSETS.ACCESS.${option}`, { defaultValue: option })}
				value={filters.access || []}
				onChange={handleChange("access")}
				filterSelectedOptions
				renderTags={(value, getTagProps) =>
					value.map((option, index) => {
						const { key, ...tagProps } = getTagProps({ index });
						return (
							<Chip
								key={key}
								label={t(`ASSETS.ACCESS.${option}`, { defaultValue: option })}
								{...tagProps}
							/>
						);
					})
				}
				renderInput={params => (
					<TextField
						{...params}
						label={t("SOURCES.FILTERS.access")}
						placeholder={t("SOURCES.FILTERS.selectAccess")}
						size="small"
						sx={{ minWidth: 200 }}
					/>
				)}
			/>

			{/* File Type Filter */}
			<Autocomplete
				multiple
				id="type-filter"
				options={fileTypeLabels.map(option => option.value)}
				getOptionLabel={getTypeDisplayLabel}
				value={filters.type || []}
				onChange={handleChange("type")}
				filterSelectedOptions
				renderTags={(value, getTagProps) =>
					value.map((option, index) => {
						const { key, ...tagProps } = getTagProps({ index });
						return <Chip key={key} label={getTypeDisplayLabel(option)} {...tagProps} />;
					})
				}
				renderInput={params => (
					<TextField
						{...params}
						label={t("SOURCES.FILTERS.type")}
						placeholder={t("SOURCES.FILTERS.selectType")}
						size="small"
						sx={{ minWidth: 200 }}
					/>
				)}
			/>
		</Box>
	);
};

export default AssetFilters;
